import React, { Component, Fragment } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import Config from 'config'
import { getConversationById, getUserById, getMostRecentMessages } from 'api/conversations'
import { filter, head, pipe, prop, propEq } from 'ramda'

import { Div, H5, A, Loader, Span } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

const mapStateToProps = state => ({	
  inboxId: state.embed?.configuration?.inboxId
})

class ConvoEvent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      lastMessageAuthor: null,
      loading: true
    }
  }

  componentDidMount() {
    this.fetchLastMessageAuthor()
  }

  fetchLastMessageAuthor = async () => {
    const { event } = this.props

    const conversationId = event.body.conversation.id
    const conversation = await getConversationById(conversationId)
    
    let lastMessageAuthorId = conversation.data.lastMessageAuthorId
    const currentEndUserId = conversation.data.endUserId

    if (lastMessageAuthorId === currentEndUserId) {
      const mostRecentMessages = await getMostRecentMessages(conversationId, 5)
      lastMessageAuthorId = this.getLastMessageUserAuthor(mostRecentMessages.data.data)
    }

    if (!lastMessageAuthorId) {
      this.setState({
        loading: false
      })

      return
    }

    try {
      const lastMessageAuthor = await getUserById(lastMessageAuthorId)

      this.setState({
        lastMessageAuthor: lastMessageAuthor.data
      })
    } catch(e) {
      return
    } finally {
      this.setState({
        loading: false
      })
    }
  }

  getLastMessageUserAuthor = (messages) => {
    return pipe(
      filter(propEq('authorType', 'USER')),
      filter(propEq('type', 'CHAT')),
      head(),
      prop('authorId')
    )(messages)
  }

  render() {
    const { event, name, inboxId: inboxIdFromProps } = this.props
    const { lastMessageAuthor, loading } = this.state

    const conversationPreviewString = event.body.conversation.preview;

    let lastMessageAuthorName = 'your Bot'
    if (lastMessageAuthor) {
      lastMessageAuthorName = lastMessageAuthor.name || lastMessageAuthor.email
    }

    const conversation = event.body.conversation
    const inboxId = conversation.inboxId || inboxIdFromProps
    const convoHref = `${Config.INBOX_URL}/${inboxId}/conversations/${conversation.id}`

    const eventBody = (
      <Fragment>
        <H5>
          {name} talked to {lastMessageAuthorName}
        </H5>
        <Span>{moment(event.createdAt).format('MM/DD/YYYY hh:mm A')}</Span>
        <Div className="contact-event--event-preview">
          <A type="subtle" href={convoHref} target="_blank">
            {
              conversationPreviewString
                ? conversationPreviewString
                : "View the conversation"
            }
          </A>
        </Div>
      </Fragment>
    )

    return (
      <Div className="contact-event--container">
        <Div className="contact-event--icon-long">
          <Icon name="comments-1" width={20} />
        </Div>
        <Div className="contact-event--event-description">
          {loading ? <Loader type="table" /> : eventBody}
        </Div>
      </Div>
    )
  }
}

export default connect(mapStateToProps)(ConvoEvent)
